var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 69,
    viewBox: "0 0 74 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.998 67.4617L35.9996 67.4628C36.1082 67.544 36.2185 67.6153 36.3445 67.696C36.7188 67.9111 37.1162 68.0199 37.5187 68.0199C37.9722 68.0199 38.4383 67.8842 38.8283 67.6259C41.8498 65.5777 45.9671 62.2565 51.1105 57.7459L51.1107 57.7458C57.721 51.9544 62.7633 46.9028 66.2877 42.5603C69.8211 38.2068 71.7899 34.6127 72.3238 31.7345L72.3277 31.7134L72.3334 31.6927C72.9737 29.3724 73.2883 26.9292 73.2632 24.416C73.1119 11.4056 63.8207 0.939941 52.6825 0.939941H52.2889C46.4155 1.02089 41.0073 3.76427 37.189 8.44509L36.8113 8.90804L36.4222 8.45474C32.5431 3.93646 27.1217 1.33708 21.1652 1.33671C15.9486 1.36368 10.9811 3.63703 7.18767 7.7563C3.01638 12.2929 0.661408 18.72 0.73693 25.376L0.736938 25.3766C0.76213 27.8929 1.12769 30.3198 1.76418 32.3463L1.77129 32.3689L1.77623 32.3921C2.4166 35.4048 4.44137 38.9541 8.06166 43.2009C11.6757 47.4403 16.8447 52.3347 23.7119 58.0382C27.2004 60.9221 32.3846 64.7766 34.8268 66.5924C34.9134 66.6567 34.9965 66.7185 35.0759 66.7776L35.998 67.4617ZM35.998 67.4617L35.0764 66.7779L35.998 67.4617Z",
    fill: "#F57D7D",
    stroke: "#F57D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconVideo);
export default __webpack_public_path__ + "static/media/fav-icon-video.19fd2b0b44d1f58f8b1cc5b823921929.svg";
export { ForwardRef as ReactComponent };